import {
  SET_FORM, FETCH_BANKS, SET_STATE, CHANGE_FORM,
  PAYMENT_CONFIRM, PAYMENT_NOT_SUPPORTED
} from './types';


export function setForm(payload) {
  return {
    type: SET_FORM,
    payload: payload
  }
}

export function setBankList(data) {
  return {
    type: FETCH_BANKS,
    payload: data
  }
}

export function setState(data) {
  return {
    type: SET_STATE,
    payload: data
  }
}

export function changeForm(data) {
  return {
    type: CHANGE_FORM,
    payload: data
  }
}

export function paymentConfirm(data) {
  return {
    type: PAYMENT_CONFIRM,
    payload: data
  }
}

export function paymentNotSupported(data) {
  return {
    type: PAYMENT_NOT_SUPPORTED,
    payload: data
  }
}




// WEBPACK FOOTER //
// ./src/ZWallet/Payment/actions.js